import type { SvgComponent } from '@/types/SvgComponent';

export const NavigateIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}

      <path
        d="M12.7459 12.7421L20.4662 10.5859C20.6175 10.5395 20.7503 10.4465 20.8455 10.3201C20.9407 10.1936 20.9935 10.0403 20.9963 9.8821C20.9992 9.72386 20.9518 9.56878 20.8612 9.43907C20.7705 9.30935 20.6411 9.21165 20.4915 9.15994L3.9915 3.03994C3.85914 2.99493 3.71682 2.9878 3.58063 3.01937C3.44443 3.05095 3.31977 3.11996 3.22072 3.21863C3.12166 3.31729 3.05216 3.44168 3.02005 3.57775C2.98794 3.71382 2.9945 3.85616 3.039 3.98869L9.159 20.4887C9.2107 20.6383 9.30841 20.7677 9.43812 20.8584C9.56783 20.949 9.72291 20.9964 9.88115 20.9935C10.0394 20.9907 10.1927 20.9379 10.3191 20.8427C10.4455 20.7475 10.5386 20.6147 10.5849 20.4634L12.7459 12.7421Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
